module.exports = __webpack_public_path__ + "images/gradients/gradient-rainbow.cfe7f3d3d204a3b9840a.svg";